import { Auth } from 'aws-amplify';
import {
    Button,
    Dropdown,
    DropdownButton,
    InputGroup,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/textLogo.svg';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { ToggleIsSidebarOpen } from '../../store/slice/common.slice';
import {
    getAuthenticatedUserEmail,
    getAuthenticatedUserName,
} from '../../store/selector/user.selector';
import { getIsSidebarOpen } from '../../store/selector/common.selector';
import { setStoreInitialState } from '../../utils/state.utils';

interface IProps {
    showSidebarToogleButton: boolean;
    store: any;
}

const PrivateHeader = ({ showSidebarToogleButton, store }: IProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const authenticatedUserName = useAppSelector(getAuthenticatedUserName);
    const authenticatedUserEmail = useAppSelector(getAuthenticatedUserEmail);
    const isSidebarOpen = useAppSelector(getIsSidebarOpen);
    const isSocialPage = location.pathname === '/social';
    const isMobile = window.innerWidth <= 768;

    const handleLogout = async () => {
        if (store) {
            store.clear();
        }
        Auth.signOut().then(() => {
            setStoreInitialState(dispatch);
            navigate('/login', { replace: true });
        });
    };

    const toggleSidebar = () => {
        dispatch(ToggleIsSidebarOpen());
    };

    const redirectToRooT = () => {
        navigate('/');
    };

    return (
        <>
            <div className="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-1000 tw-w-full tw-bg-gray-50 tw-flex tw-justify-between tw-items-center tw-h-12 tw-px-4 tw-border tw-border-purple-500 tw-border-opacity-20">
                <div className="tw-flex tw-items-center tw-gap-x-4">
                    <div onClick={redirectToRooT}>
                        <img src={Logo} className="tw-cursor-pointer tw-h-4 tw-w-11" />
                    </div>
                    {showSidebarToogleButton && !isSocialPage && (
                        <>
                            {isMobile ? (
                                <Button
                                    variant="primary"
                                    className="iconbtn rounded-circle"
                                    onClick={toggleSidebar}
                                >
                                    {isSidebarOpen ? (
                                        <i className="ph ph-caret-left"></i>
                                    ) : (
                                        <i className="ph ph-caret-right"></i>
                                    )}
                                </Button>
                            ) : (
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 150, hide: 400 }}
                                    overlay={
                                        <Tooltip>
                                            {isSidebarOpen ? 'Close Sidebar' : 'Open Sidebar'}
                                        </Tooltip>
                                    }
                                >
                                    <Button
                                        style={{
                                            backgroundColor: '#e5e5e5',
                                        }}
                                        variant="secondary"
                                        className="iconbtn rounded-circle"
                                        onClick={toggleSidebar}
                                    >
                                        {isSidebarOpen ? (
                                            <i className="ph ph-caret-left"></i>
                                        ) : (
                                            <i className="ph ph-caret-right"></i>
                                        )}
                                    </Button>
                                </OverlayTrigger>
                            )}
                        </>
                    )}
                </div>

                <div className="custom_nav-profile tw-flex tw-items-center tw-gap-x-2">
                    {!isSocialPage && (
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip>Scheduler</Tooltip>}
                        >
                            <Button
                                variant="outline-primary"
                                className={`iconbtn rounded-circle ${isSocialPage ? 'activeMode' : ''}`}
                                onClick={() => navigate('/social')}
                                style={{
                                    transition: 'all 0.3s ease-in-out',
                                }}
                            >
                                <i className="ph ph-timer md"></i>
                            </Button>
                        </OverlayTrigger>
                    )}
                    <InputGroup className="custom-dropdown">
                        <DropdownButton
                            align="end"
                            title={<i className="ph ph-user lg"></i>}
                            id="dropdown-menu-align-end"
                            className="dropdown__toggle"
                        >
                            <Dropdown.Header className="mt-2 mb-2">
                                <h3 className="fw-semibold ">{authenticatedUserName}</h3>
                                <p className="text-muted m-0 ">{authenticatedUserEmail}</p>
                            </Dropdown.Header>
                            <Dropdown.Item onClick={() => navigate('/brandProfile')}>
                                <i className="ph ph-magic-wand sm"> </i>Brand Profile
                            </Dropdown.Item>
                            {isMobile && (
                                <>
                                    <Dropdown.Item href="mailto:monte@pixii.ai,risa@pixii.ai">
                                        <i className="ph ph-envelope-simple"></i> Get help or Share
                                        feedback
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={(e) => {
                                            window.location.href = '/faq';
                                            e.preventDefault();
                                        }}
                                    >
                                        <i className="ph ph-arrow-square-out"></i> Help & FAQ
                                    </Dropdown.Item>
                                </>
                            )}
                            <Dropdown.Item onClick={handleLogout}>
                                <i className="pxi-log-out-2 sm"></i> Sign out
                            </Dropdown.Item>
                        </DropdownButton>
                    </InputGroup>
                </div>
            </div>
        </>
    );
};
export default PrivateHeader;
